const baseStyle = {
  borderRadius: 'md',
  p: 3,
};

const defaultProps = {
  variant: 'ghost',
  size: 'md',
};

const sizes = {
  lg: {
    p: 4,
  },
  md: {
    p: 3,
  },
  sm: {
    p: 2,
  },
};

export default {
  baseStyle,
  sizes,
  defaultProps,
};
